import React from 'react';
import { Link } from 'react-router-dom';
import Button from "./ui/Button";
import {
  Phone,
  Mail,
  Clock
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-secondary  pb-8">
      <div className="max-w-6xl mx-auto px-4 py-12 md:px-0 px-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold mb-4">Serenoly</h3>
            <p className="text-sm leading-relaxed">
              Serenoly connects clients with verified massage therapists for sessions at home, in a hotel room, or at a partner spa &mdash; with escrow-protected payments and real-time matching.
            </p>
          </div>

          {/* Quick Links */}
          <div className="grid grid-cols-2 gap-8 md:gap-4">
            <div>
              <h3 className="text-lg font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="../" className="hover:text-accent-hard transition-colors">Home</Link></li>
                <li><Link to="../about" className="hover:text-accent-hard transition-colors">About Us</Link></li>
                <li><Link to="../book-massage" className="hover:text-accent-hard transition-colors">Book a Massage</Link></li>
                <li><Link to="../faq" className="hover:text-accent-hard transition-colors">FAQ</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-bold mb-4">Services</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="../massage-therapy" className="hover:text-accent-hard transition-colors">Massage Therapy</Link></li>
                <li><Link to="../signup" className="hover:text-accent-hard transition-colors">Become a Therapist</Link></li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-4 text-sm">
              {/* <li className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-accent-hard" />
                <span>123 Spa Street, Beauty City, BC 12345</span>
              </li> */}
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-accent-hard" />
                <span>(+234) 812 907 7871</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-accent-hard" />
                <a href="mailto:info@serenoly.udoemmanuel.com" className="hover:text-accent-hard transition-colors">
                  info@serenoly.udoemmanuel.com
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Clock className="w-4 h-4 text-accent-hard" />
                <div>
                  <p>Mon-Sun: 9:00 AM - 5:00 PM</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Newsletter & Booking */}
          <div className="space-y-6 md:px-0 pr-12">
            {/* <div>
              <h3 className="text-lg font-bold mb-4">Newsletter</h3>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="px-4 py-2 rounded-l w-full border-gray-300 focus:outline-none focus:ring-2 focus:ring-accent-hard text-sm"
                />
                <button className="bg-accent-hard text-white px-4 py-2 rounded-r hover:bg-accent-muted transition-colors">
                  <Send className="w-4 h-4" />
                </button>
              </div>
            </div> */}

            <div>
              <Button
                to="../book-massage"
                variant="accent"
                size="medium"
                className="w-full justify-center"
              >
                BOOK AN APPOINTMENT
              </Button>
            </div>
          
          {/* Payment Methods */}
            <div className="text-sm">
              <h4 className="font-bold mb-2">We Accept</h4>
              <div className="flex space-x-2">
                <span className="px-2 py-1 bg-accent text-primary-dark rounded text-xs">VISA</span>
                <span className="px-2 py-1 bg-secondary/20 text-secondary rounded text-xs">MASTERCARD</span>
                <span className="px-2 py-1 bg-secondary/20 text-secondary rounded text-xs">VERVE</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-400">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div className="text-center md:text-left">
              © {new Date().getFullYear()} Serenoly. All rights reserved
            </div>
            <div className="text-center md:text-right space-x-4">
              <Link to="../privacy-policy" className="hover:text-accent-hard transition-colors">Privacy Policy</Link>
              <Link to="../terms-of-service" className="hover:text-accent-hard transition-colors">Terms of Service</Link>
              {/* <Link to="../" className="hover:text-accent-hard transition-colors">Cookie Policy</Link */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;